import { useEffect } from 'react';
import { Drawer, IconButton, Typography } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import { Progress } from '@backstage/core-components';
import { AskAiCodebase } from './AskAiCodebase';
import { AskAiSearch } from './AskAiSearch';
import { useAskAiStyles } from './askAiStyles';
import type { CodebaseConversation } from './useCodebaseConversation';

/**
 * The Ask AI slide-out. Members of a codebase group ask questions about
 * their product's code; everyone else searches Univerus Central. The scope
 * call that decides between them runs on the first open only.
 */
export function AskAiDrawer({
  open,
  onClose,
  conversation,
}: {
  open: boolean;
  onClose: () => void;
  conversation: CodebaseConversation;
}) {
  const classes = useAskAiStyles();
  const { scope, loadScope } = conversation;
  useEffect(() => {
    if (open) loadScope();
  }, [open, loadScope]);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        className: classes.drawer,
        role: 'dialog',
        'aria-modal': true,
        'aria-labelledby': 'ask-ai-title',
        'aria-describedby': 'ask-ai-description',
      }}
    >
      <div className={classes.head}>
        <Typography component="h2" id="ask-ai-title" className={classes.label}>
          Ask AI
        </Typography>
        <IconButton onClick={onClose} aria-label="Close Ask AI">
          <Close />
        </IconButton>
      </div>
      {scope.status === 'member' && (
        <AskAiCodebase repos={scope.repos} conversation={conversation} />
      )}
      {scope.status === 'search' && <AskAiSearch onClose={onClose} />}
      {(scope.status === 'loading' || scope.status === 'unknown') && (
        <Progress />
      )}
    </Drawer>
  );
}
